import { call, takeLatest, all, put } from "redux-saga/effects";
import { storeGodownResult } from "./actions";
import { getHeaderJWT, URL } from "../../../store/path";
import { handlError, parseError } from "../../app/serverError";
import axios from "axios";

function* watchGodownSearch() {
  yield takeLatest("SEARCH_GODOWN", initiateSearch);
}

function* initiateSearch(action) {
  let { response, error } = yield call(searchAPI, action.payload, action.cid);
  if (response) {
    try {
      let getData = getDataAfterArrange(response.data.data);
      yield put(storeGodownResult(getData, action.name));
    } catch (error) {
      sagaErrorMessage(error, action);
    }
  } else {
    yield put(handlError(action, parseError(error)));
    sagaErrorMessage(error, action);
  }
}

function getDataAfterArrange(data) {
  if (!Array.isArray(data)) {
    console.error("Invalid data format: Expected an array", data);
    return [];
  }

  return data.map((item) => ({
    ...item, // Keep existing properties
    key: item.name,
    value: item.name,
    text: item.name,
    title: item.name,
  }));
}

async function searchAPI(data, cid) {
  let head = getHeaderJWT();
  try {
    let apiUrl = `${URL}/master/rlb/allGodown`;
    if (cid) apiUrl += `/${cid}`;
    const response = await axios.post(
      apiUrl,
      data,
      head
    );
    return { response };
  } catch (error) {
    return { error };
  }
}

//#endregion

const sagaErrorMessage = (error, action) => {
  console.group("Saga Error:" + action.type);
  console.log(error);
  console.groupEnd();
};

export default function* godownSearchSaga() {
  yield all([watchGodownSearch()]);
}
